// extracted by mini-css-extract-plugin
module.exports = {"main":"hero-text-module--main--25b07"};